import { useClientPortalSubmit } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { LinkButton, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useUser } from "../../hooks/useUser";

interface Props {
  title?: string;
  message?: string;
  type?: "warning" | "danger";
}

export function EmailVerificationBanner(props: Props) {
  const { t } = useTranslation();

  const {
    title = t("Please verify your email to keep your account active."),
    message = t(
      "Without verification, your account will be blocked after 14 days."
    ),
    type = "warning",
  } = props;

  const { details: userDetails } = useUser();

  const { submit, isSubmitting, response } = useClientPortalSubmit(
    "/api/internal/client-portal/me/resend-email-validation/",
    {
      onFailure() {
        showToast(t("Unable to resend verification email. Try again later."), {
          type: "error",
        });
      },
      onSuccess() {
        showToast(t("Verification email has been successfully sent."));
      },
    }
  );

  if (userDetails?.auth0_email_verified) {
    return null;
  }

  return (
    <SectionMessage
      sectionTitle={title}
      icon={type === "danger" ? "error" : "warning"}
      type={type}
    >
      {message}{" "}
      {!response && !isSubmitting && (
        <LinkButton
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          onPress={() => submit()}
          testID={"email-verification-link"}
        >
          {t("Resend verification email")}
        </LinkButton>
      )}
    </SectionMessage>
  );
}
